import React, { useCallback } from "react";
import { useCurrentProject } from "@radarly/core/project/use-cases";
import { DateMetricCard } from "@radarly/models/cards";
import { isTimeUnitCard } from "@radarly/models/cards/is";
import { getDateFromClause } from "@radarly/models/clause/getter";
import { isKpiDataviz } from "@radarly/models/dataviz";
import { getPostSortFromMetric } from "@radarly/models/posts";
import { useFragments } from "../fragment";
import { useGenerateCSV } from "../hooks/useGenerateCSV";
import { CardProps } from "../model";
import Kpi from "./kpi";
import LineChart from "./line-chart";

const RadarlyMetricCard = ({
  card,
  clause,
  from,
  to,
  height,
  timezone,
  forceReload,
  openPostsPanel,
  nowDate,
  isEdition,
}: CardProps<DateMetricCard>) => {
  const project = useCurrentProject();
  const timeUnit = isTimeUnitCard(card) ? card.dataviz.timeUnit : undefined;
  const fragments = useFragments(
    [card.fragments[0], card.fragments[1]],
    clause,
    from,
    to,
    timezone,
    timeUnit
  );
  const { onGenerateCSV } = useGenerateCSV(
    card.title,
    fragments[0],
    fragments[1]
  );

  const dataviz = card.dataviz;
  const fragment = fragments[0];
  const title = card.title;
  const onClickItem = useCallback(
    (_, range?: { from: Date; to: Date }) => {
      const { from, to } = getDateFromClause(fragment.request.query);
      openPostsPanel({
        clause: fragment.request.query,
        period: {
          from: range ? range.from : from,
          to: range ? range.to : to,
        },
        title,
        sortBy: getPostSortFromMetric(fragment.request.aggs.date.metrics[0]),
        timezone,
      });
    },
    [
      fragment.request.aggs.date.metrics,
      fragment.request.query,
      openPostsPanel,
      timezone,
      title,
    ]
  );
  return isKpiDataviz(dataviz) ? (
    <Kpi
      fragments={fragments}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      onClickItem={openPostsPanel ? onClickItem : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
      onGenerateCSV={onGenerateCSV}
    />
  ) : (
    <LineChart
      fragments={fragments}
      project={project}
      dataviz={dataviz}
      title={title}
      height={height}
      onClickItem={openPostsPanel ? onClickItem : null}
      timezone={timezone}
      forceReload={forceReload}
      nowDate={nowDate}
      onGenerateCSV={onGenerateCSV}
    />
  );
};

export default RadarlyMetricCard;
